module.exports = __webpack_public_path__ + "img/E306.e4fdee61.svg";